<template>
  <div class="lxm-login">
    <img class="lxm-login__background" src="../images/login/bg.jpg">
    <div class="lxm-login__container">
      <img class="lxm-login__logo" src="../images/login/logo.png">

      <div class="lxm-login-org">
        <div class="lxm-login-org__subtitle">
          您的用户名在以下机构中，请选择：
        </div>

        <template v-for="org in orgs">
          <div class="lxm-login-org__org" @click="orgClicked(org)">
            <div class="lxm-login-org__name">
              {{ org.name }}
            </div>
            <div class="lxm-login-org__domain">
              {{ org.domain }}
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../styles/index.styl'
  .lxm-login
    // background: register-gradient
    // background: url('../images/login/bg.jpg') no-repeat
    // background-size: 100%
    color: white
    width: 100vw
    min-height: siz(667)
  .lxm-login__background
    position: fixed
    width: 100vw
  .lxm-login__container
    position: relative
    width: login-width
    margin: 0 auto
    padding-top: siz(110)
  .lxm-login__logo
    display: block
    height: siz(27)
    margin: 0 auto siz(95)
  .lxm-login__logo-text
    position: absolute
    top: siz(150)
    width: 100%
    text-align: center
    font-size: size-big
    font-weight: bold
  .lxm-login-org__subtitle
    font-size: size-smaller
    margin-bottom: spacing-small
  .lxm-login-org__org
    background-color: login-primary
    text-align: center
    border-radius: login-radius
    padding: spacing
    margin-bottom: spacing // <-- last-child 的当作底边距
    &:not(:last-child)
      margin-bottom: spacing
  .lxm-login-org__name
    font-size: size-big
  .lxm-login-org__domain
    font-size: size-small
    margin-top: spacing-small
</style>

<script>
  import * as mTypes from '../../store/mutation-types'
  import * as aTypes from '../../store/action-types'
  export default {
    computed: {
      state () {
        return this.$store.state.login
      },
      orgs () {
        return this.state.orgs
      }
    },
    methods: {
      orgClicked (org) {
        this.$store.commit(mTypes.LOGIN_UPDATE, { teamId: org.id })
        if (this.state.loginByMail) {
          this.$store.dispatch(aTypes.LOGIN_WITH_EMAIL, {
            mail: this.state.email,
            password: this.state.loginPassword,
            teamId: this.state.teamId
          })
        } else {
          this.$store.dispatch(aTypes.LOGIN_WITH_PHONE, {
            phoneNumber: this.state.verifiedPhone,
            smsCaptcha: this.state.smsVerifCode,
            teamId: this.state.teamId
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Org.vue?ef3e133c